export default __webpack_public_path__ + "adf5794ebdf80fa6a3f2607eb240ee20.svg";